var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('label',{class:'label label-'+(_vm.data.style),style:(_vm.data.color ? 'background-color:'+_vm.data.color+' !important; color:#fff;' : '')},[_vm._v(_vm._s(_vm.data.label))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }